import React from 'react';
import 'react-lazy-load-image-component/src/effects/blur.css';
import unsafeImageUrl from '../images/lineup-default.png';
import { formatCentsToUSD } from '../../../../../../../shared/lib/utils';
import WideImage from './WideImage';
import SpinnerButton from './SpinnerButton';
import { useApp } from '../context/AppContext';
import urljoin from 'url-join';

export interface SquareCardProps {
  name: string;
  price: number;
  description?: string;
  image?: string;
  amount?: number;
  setAmount?: (amount: number) => void;
}

export default function SquareCard(props: SquareCardProps) {
  const { config } = useApp();
  const { name, description, price, image, amount = 0, setAmount } = props;

  const defaultImgUrl = urljoin(config.goBaseUrl, unsafeImageUrl);

  return (
    <div className="h-full flex flex-col rounded-lg overflow-hidden border border-border bg-white">
      <WideImage image={image || defaultImgUrl} title={name} className="rounded-0-i" />
      <div className="p-6 flex flex-col h-full gap-4">
        <div className="font-bold text-xl text-accent">{name}</div>
        <div>{formatCentsToUSD(price)}</div>
        {setAmount && (
          <SpinnerButton type="package" singleMode amount={amount} setAmount={setAmount} block />
        )}
        {description && (
          <div className="html-view" dangerouslySetInnerHTML={{ __html: description }}></div>
        )}
      </div>
    </div>
  );
}
